import { atsApiQuery } from '..';
import { FILTER_OPTIONS_STALE_SECONDS } from '@/constants/app-constants';

export const officesApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAtsOffices: builder.query({
        providesTags: ['GetAtsOffices'],
        // Admin-managed config. The 60s default evicted it between page visits,
        // which forced a refetch no freshness window could prevent.
        keepUnusedDataFor: FILTER_OPTIONS_STALE_SECONDS,
        transformResponse: (response) => response?.data,
        query: ({ params = {} } = {}) => {
          return {
            method: 'get',
            url: `/ats_offices`,
            params,
          };
        },
      }),

      getAtsCountries: builder.query({
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/ats_offices/country_list`,
          };
        },
      }),

      createOffice: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload = {}) => {
          return {
            method: 'post',
            url: `/ats_offices`,
            data: payload,
          };
        },
        invalidatesTags: ['GetAtsOffices'],
      }),

      editOffice: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ officeId, payload = {} }) => {
          return {
            method: 'put',
            url: `/ats_offices/${officeId}`,
            data: payload,
          };
        },
        invalidatesTags: ['GetAtsOffices'],
      }),

      getOfficeLocationDependentCount: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { officeId } = payload;
          return {
            method: 'get',
            url: `/ats_offices/${officeId}/dependent_count`,
          };
        },
      }),

      deleteOfficeLocation: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ officeId = null, params = {} } = {}) => {
          return {
            method: 'delete',
            url: `/ats_offices/${officeId}/delete`,
            data: params,
          };
        },
        invalidatesTags: ['GetAtsOffices'],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetAtsOfficesQuery,
  useGetAtsCountriesQuery,
  useCreateOfficeMutation,
  useDeleteOfficeLocationMutation,
  useGetOfficeLocationDependentCountMutation,
  useEditOfficeMutation,
} = officesApi;
